//=================================================
//    summary: DCP Content 分頁 -- Hook
//
//    remarks: 000 Tim 2021/11/15 Create
//             001 Tim 2021/12/23 加入 PaintedMe流程
//================================================
import React, { useState, useEffect, useRef } from 'react'
import cssContent from './Content.module.scss'
import {LocalStorageLibs, GlobalLibs, NetworkLibs, PackageVariablesLibs} from 'bc-react-package'

// #region Member Variables
let mblnInitialized = false

let mintAccountRole = 0
let mobjCallParam = null
// #endregion Member Variables

// #region Enumeration
const SwitchButtonTypeEnum = {
    "ShowPractice": 1,     
    "ShowReview": 2,
    "ShowAnswer4Submission": 3,
    "TimeDST": 4
}

export const SwitchValueEnum = {
    "OFF": 0,
    "ON": 1
}

const SubmissionTypeEnum = {
    "Once": 1,     
    "Twice": 2,
    "Unlimited": 99
}
// #endregion Enumeration

const COMP_NAME = "Content"

function Content(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [updateDataTime, setUpdateDataTime] = useState(0)
    const [language, setLanguage] = useState(window.gSession.Acc.Preferences.Lang)
    const [showPractice, setShowPractice] = useState(SwitchValueEnum.ON)
    const [showReview, setShowReview] = useState(SwitchValueEnum.ON)
    const [showAnswer4Submission, setShowAnswer4Submission] = useState(SwitchValueEnum.OFF)
    const [testedCountMax, setTestedCountMax] = useState(SubmissionTypeEnum.Unlimited)
    // #endregion Init State

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    
    mrefPaintedMe.current = PaintedMe
    // #endregion Init Function Ref
    
    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)    
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            
            mintAccountRole = 0
            mblnInitialized = false
            setUpdateDataTime(0)
        }
    }, [props.ClassIndex])


    // #region OnTapHandler
    /*===========================================
    summary: Content頁面 點選 Submit
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function ContentSubmitOnTapHandler(StateLanguage, StateShowPractice
        , StateShowReview, StateShowAnswer4Submission, StateTestedCountMax)
    {
        console.log(COMP_NAME + ".ContentSubmitOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        console.log(COMP_NAME + ".Preferences", window.gSession.Acc.Preferences)

        console.log(COMP_NAME + ".StateLanguage", StateLanguage)

        let arrPref = []
        let objPref = {}
        let blnIsSubmitClass = false

        // Language
        if (StateLanguage !== window.gSession.Acc.Preferences.Lang)
        {
            window.gSession.Acc.Preferences.Lang = StateLanguage

            objPref = {
                "Key": window.gAccPreferenceTypeEnum.Lang,
                "Value": window.gSession.Acc.Preferences.Lang
            }
            arrPref.push(objPref)

            // window.gSession.Acc.SettingsDirtyFunc[window.gSettingsFuncIndexEnum.LangChange] = true

            let objCallbackData = {
                "Action": "LangChange"
            }
            props.CallbackRef(objCallbackData)
        } // end of if (StateLanguage !== window.gSession.Acc.Preferences.Lang)

        let intShowPractice = SwitchValueEnum.ON
        let intShowReview = SwitchValueEnum.ON
        let intShowAnswer4Submission = SwitchValueEnum.OFF
        let intTestedCount = SubmissionTypeEnum.Unlimited

        if (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
        {
            if (
                (parseInt(window.gSession.Acc.Class[props.ClassIndex].IsDCPSectionPracticeShow) !== StateShowPractice) || 
                (parseInt(window.gSession.Acc.Class[props.ClassIndex].IsDCPSectionHWShow) !== StateShowReview) ||
                (parseInt(window.gSession.Acc.Class[props.ClassIndex].IsDCPAnswerShow) !== StateShowAnswer4Submission) ||
                (parseInt(window.gSession.Acc.Class[props.ClassIndex].DCPTestedCountMax) !== StateTestedCountMax)
                )
            {
                blnIsSubmitClass = true;

                intShowPractice = StateShowPractice
                intShowReview = StateShowReview
                intShowAnswer4Submission = StateShowAnswer4Submission
                intTestedCount = StateTestedCountMax
            }
        } // end of if (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)

        if (
            (arrPref.length > 0) || 
            (blnIsSubmitClass)
            )
        {
            ExecuteSubmit(arrPref, blnIsSubmitClass
                , intShowPractice, intShowReview
                , intShowAnswer4Submission, intTestedCount)
        }
        else
        {
            ExecuteSubmitSuccessAlert()
        }
    } // end of ContentSubmitOnTapHandler

    /*===========================================
    summary: Content頁面 點選 選擇語言
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function ContentLanguageOnTapHandler(Language)
    {
        console.log(COMP_NAME + ".ContentLanguageOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        setLanguage(Language)
    } // end of ContentLanguageOnTapHandler

    /*===========================================
    summary: 點選 Switch元件 OFF / ON
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function SwitchButtonOnTapHandler(SwitchButtonType, SwitchValue)
    {
        console.log(COMP_NAME + ".SwitchButtonOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        switch (SwitchButtonType)
        {
            case SwitchButtonTypeEnum.ShowPractice:
                setShowPractice(SwitchValue)
                break
            case SwitchButtonTypeEnum.ShowReview:
                setShowReview(SwitchValue)
                break
            case SwitchButtonTypeEnum.ShowAnswer4Submission:
                setShowAnswer4Submission(SwitchValue)
                break
            default:
                break
        } // end of switch (SwitchButtonType)
    } // end of SwitchButtonOnTapHandler

    /*===========================================
    summary: 點選 學生作答次數 Radio元件
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function RadioOnTapHandler(TestedCountMax)
    {
        console.log(COMP_NAME + ".RadioOnTapHandler: TestedCountMax: ", TestedCountMax)
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        setTestedCountMax(TestedCountMax)
    } // end of RadioOnTapHandler
    // #endregion OnTapHandler

    // #region LoadingMask and Alert Functions
    /*===========================================
    summary: 開啟 讀取中 效果
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log(COMP_NAME + ".OpenLoadingMask")

        let objCallbackData = {
            "Action": "OpenLoadingMask",
            "Message": LoadingMsg
        }
        props.CallbackRef(objCallbackData)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 讀取中 效果
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")

        let objCallbackData = {
            "Action": "CloseLoadingMask"
        }
        props.CallbackRef(objCallbackData)
    } // end of CloseLoadingMask

    /*===========================================
    summary: 顯示 提示視窗
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function ShowAlert(AlertObject)
    {
        let objCallbackData = {
            "Action": "ShowAlertWindow",
            "AlertObject": AlertObject
        }
        props.CallbackRef(objCallbackData)
    } // end of ShowAlert
    // #endregion LoadingMask and Alert Functions

    // #region Other Functions
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2021/12/23 Create
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        mintAccountRole = window.Globals.GetClassAccountRole(props.ClassIndex)

        InitStateMemberVariables()
    } // end of PaintedMe

    /*===========================================
    summary: 初始化 State 變數
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function InitStateMemberVariables()
    {
        console.log(COMP_NAME + ".InitStateMemberVariables")

        if (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
        {
            let intDCPTestedCountMax = SubmissionTypeEnum.Unlimited
            if (isNaN(parseInt(window.gSession.Acc.Class[props.ClassIndex].DCPTestedCountMax)))
            {
                intDCPTestedCountMax = SubmissionTypeEnum.Unlimited
            }
            else
            {
                intDCPTestedCountMax = parseInt(window.gSession.Acc.Class[props.ClassIndex].DCPTestedCountMax)
            }

            setShowPractice(parseInt(window.gSession.Acc.Class[props.ClassIndex].IsDCPSectionPracticeShow))
            setShowReview(parseInt(window.gSession.Acc.Class[props.ClassIndex].IsDCPSectionHWShow))
            setShowAnswer4Submission(parseInt(window.gSession.Acc.Class[props.ClassIndex].IsDCPAnswerShow))
            setTestedCountMax(intDCPTestedCountMax)
        }

        setUpdateDataTime(new Date().getTime())
    } // end of InitStateMemberVariables

    /*===========================================
    summary: 跳出 送出成功 提示
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function ExecuteSubmitSuccessAlert()
    {
        let objAlertObject = {
            Header: "",
            Body: window.gAppUI.MSG_SubmitSuccess,
            ShowCloseButton: false,
            CallbackRef: null,
            Buttons: [
                {
                    Text: PackageVariablesLibs.UISettings.BTN_OK,
                    AutoFocus: true
                }
            ]
        }
        ShowAlert(objAlertObject)
    } // end of ExecuteSubmitSuccessAlert

    /*===========================================
    summary: 送出設定 
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function ExecuteSubmit (AccPreferencesArray, IsSubmitClass
            , ShowPractice, ShowReview, ShowAnswer4Submission, TestedCount)
    {
        console.log(COMP_NAME + ".ExecuteSubmit AccPreferencesArray: ", AccPreferencesArray)
        console.log(COMP_NAME + ".ExecuteSubmit IsSubmitClass: ", IsSubmitClass)
        console.log(COMP_NAME + ".ExecuteSubmit ShowPractice: ", ShowPractice)
        console.log(COMP_NAME + ".ExecuteSubmit ShowReview: ", ShowReview)
        console.log(COMP_NAME + ".ExecuteSubmit ShowAnswer4Submission: ", ShowAnswer4Submission)
        console.log(COMP_NAME + ".ExecuteSubmit TestedCount: ", TestedCount)

        mobjCallParam = {
            "ClassID": -1,
            "IsDCPSectionPracticeShow": -1,
            "IsDCPSectionHWShow": -1,
            "IsDCPAnswerShow": -1,
            "DCPTestedCountMax": -1,
            "AccPreferences": []
        }

        if (
            (typeof(IsSubmitClass) !== 'undefined') &&
            (IsSubmitClass !== null) &&
            (IsSubmitClass)
            )
        {
            // mobjCallParam
            mobjCallParam.ClassID = window.gSession.Acc.Class[props.ClassIndex].ClassID
            mobjCallParam.IsDCPSectionPracticeShow = ShowPractice
            mobjCallParam.IsDCPSectionHWShow = ShowReview
            mobjCallParam.IsDCPAnswerShow = ShowAnswer4Submission
            mobjCallParam.DCPTestedCountMax = TestedCount
        }

        if (AccPreferencesArray.length > 0)
        {
            mobjCallParam.AccPreferences = AccPreferencesArray
        }


        if (IsSubmitClass)
        {
            SwitchSectionShow()
        }
        else if (AccPreferencesArray.length > 0)
        {
            if (navigator.onLine)
            {
                SetAccountPreferences()
            }
            else
            {
                SetAccountPreferencesAfterProcess()
            }
        }
        else
        {
            ExecuteSubmitSuccessAlert()
        }
    } // end of ExecuteSubmit
    // #endregion Other Functions

    // #region Get ClassName
    /*===========================================
    summary: 取得 語言 按鈕 Cls
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function GetLanguageButtonCls(StateLanguage, Language)
    {
        let objCls = cssContent.btnLanguage

        if (StateLanguage === Language)
        {
            objCls = cssContent.btnLanguageSelected
        }

        return objCls
    } // end of GetLanguageButtonCls

    /*===========================================
    summary: 取得 語言 文字 Cls
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function GetLanguageTextCls(StateLanguage, Language)
    {
        let objCls = cssContent.divLanguageText

        if (StateLanguage === Language)
        {
            objCls = cssContent.divLanguageTextSelected
        }

        return objCls
    } // end of GetLanguageTextCls

    /*===========================================
    summary: 取得 切換按鈕 OFF / ON Cls
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function GetSwitchButtonCls(StateShowValue, SwitchValue)
    {
        let objCls = cssContent.btnSwitchOFF

        if (SwitchValue === SwitchValueEnum.OFF)
        {
            // OFF
            if (StateShowValue === SwitchValueEnum.OFF)
            {
                objCls = cssContent.btnSwitchOFFSelected
            }
            else
            {
                objCls = cssContent.btnSwitchOFF
            }
        }
        else
        {
            // ON
            if (StateShowValue === SwitchValueEnum.ON)
            {
                objCls = cssContent.btnSwitchONSelected
            }
            else
            {
                objCls = cssContent.btnSwitchON
            }
        }

        return objCls
    } // end of GetSwitchButtonCls

    /*===========================================
    summary: 取得 切換按鈕文字 OFF / ON Cls
    remarks: 000 Tim 2021/12/20 Create
    ===========================================*/
    function GetSwitchTextCls(StateShowValue, SwitchValue)
    {
        let objCls = cssContent.divSwitchText

        if (SwitchValue === StateShowValue)
        {
            objCls = cssContent.divSwitchTextSelected
        }

        return objCls
    } // end of GetSwitchTextCls

    /*===========================================
    summary: 取得 學生作答次數 Radio按鈕 Cls
    remarks: 000 Tim 2020/12/07 Create
    ===========================================*/
    function GetRadioButtonCls(StateTestedCountMax, SubmissionType)
    {
        let objCls = cssContent.divRadioButtonIcon

        if (StateTestedCountMax === SubmissionType)
        {
            objCls = cssContent.divRadioButtonIconSelect
        }

        return objCls
    } // end of GetRadioButtonCls
    // #endregion Get ClassName

    // #region Web Service After Process
    /*===========================================
    summary: 儲存 帳號設定後 的 流程
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function SetAccountPreferencesAfterProcess ()
    {   
        console.log(COMP_NAME + ".GetAccountDashboardAfterProcess")

        // save to local storage
        LocalStorageLibs.SetAccLSElement("Preferences", JSON.stringify(window.gSession.Acc.Preferences))

        // 重新塞入數值，以防因為 Relogin導致 window.gSession.Acc.Preferences 還原    Tim17.01.12
        let intIndex = 0
        let intCount = mobjCallParam.AccPreferences.length
        for (intIndex = 0; intIndex < intCount; intIndex++)
        {   
            switch (parseInt(mobjCallParam.AccPreferences[intIndex].Key))
            {
                case window.gAccPreferenceTypeEnum.Lang:
                    window.gSession.Acc.Preferences.Lang = mobjCallParam.AccPreferences[intIndex].Value
                    break
                default:
                    break
            }
        } // end of for (intIndex = 0;

        ExecuteSubmitSuccessAlert()

        mobjCallParam = null
    } // end of SetAccountPreferencesAfterProcess

    /*===========================================
    summary: 更新 學生Practice & Homework 等 使用權限資料 後續流程 
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function SwitchSectionShowAfterProcess ()
    {   
        console.log(COMP_NAME + ".SwitchSectionShowAfterProcess")
        
        window.gSession.Acc.Class[props.ClassIndex].IsDCPSectionPracticeShow = mobjCallParam.IsDCPSectionPracticeShow.toString()
        window.gSession.Acc.Class[props.ClassIndex].IsDCPSectionHWShow = mobjCallParam.IsDCPSectionHWShow.toString()
        window.gSession.Acc.Class[props.ClassIndex].IsDCPAnswerShow = mobjCallParam.IsDCPAnswerShow.toString()
        window.gSession.Acc.Class[props.ClassIndex].DCPTestedCountMax = mobjCallParam.DCPTestedCountMax.toString()
                  
        // LS
        LocalStorageLibs.SetAccLSElement("Class", JSON.stringify(window.gSession.Acc.Class))

        if (mobjCallParam.AccPreferences.length > 0)
        {
            if (navigator.onLine)
            {
                SetAccountPreferences()
            }
            else
            {
                SetAccountPreferencesAfterProcess()
            }
        }
        else
        {
            ExecuteSubmitSuccessAlert()
            mobjCallParam = null
        }
    } // end of SwitchSectionShowAfterProcess
    // #endregion Web Service After Process

    // #region Web Service
    /*===========================================
    summary: 更新 學生Practice & Homework 等 使用權限資料
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function SwitchSectionShow ()
    {
        let objRetryFuncRef = SwitchSectionShow
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = SwitchSectionShowCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_SwitchSectionShow)

            let objCallData = {
                "Func": "SwitchSectionShow",
                "ClassID": mobjCallParam.ClassID,
                "IsDCPSectionPracticeShow": mobjCallParam.IsDCPSectionPracticeShow,
                "IsDCPSectionHWShow": mobjCallParam.IsDCPSectionHWShow,
                "IsDCPAnswerShow": mobjCallParam.IsDCPAnswerShow,
                "DCPTestedCountMax": mobjCallParam.DCPTestedCountMax
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of SwitchSectionShow

    /*===========================================
    summary: 更新 學生Practice & Homework 等 使用權限資料 Callback
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function SwitchSectionShowCallback (Return)
    {
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_SwitchSectionShow_No
        let strErrorTitle = window.gAppUI.ERR_SwitchSectionShow_Title
        let strErrMsg = window.gAppUI.ERR_SwitchSectionShow_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("SwitchSectionShowCallback: ErrNo: ", Return.ErrNo)
            console.log("SwitchSectionShowCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("SwitchSectionShowCallback Return.Data: ", Return.Data)

            SwitchSectionShowAfterProcess()
        }
    } // end of SwitchSectionShowCallback

    /*===========================================
    summary: 儲存 帳號設定 
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function SetAccountPreferences ()
    {
        let objRetryFuncRef = SetAccountPreferences
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = SetAccountPreferencesCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_SetAccountPreferences)

            let objCallData = {
                "Func": "SetAccountPreferences",
                "PrefList": JSON.stringify(mobjCallParam.AccPreferences)
            };

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of SetAccountPreferences

    /*===========================================
    summary: 儲存 帳號設定 Callback
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function SetAccountPreferencesCallback (Return, InstructionInfo)
    {
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_SetAccountPreferences_No
        let strErrorTitle = window.gAppUI.ERR_SetAccountPreferences_Title
        let strErrMsg = window.gAppUI.ERR_SetAccountPreferences_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("SetAccountPreferencesCallback: ErrNo: ", Return.ErrNo)
            console.log("SetAccountPreferencesCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("SetAccountPreferencesCallback Return.Data: ", Return.Data)

            SetAccountPreferencesAfterProcess()
        }
    } // end of SetAccountPreferencesCallback
    // #endregion Web Service

    // #region Render元件
    /*===========================================
    summary: Allow Submission Radio Button 顯示Component  
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function ComponentAllowSubmissionRadioButton( {StateTestedCountMax, SubmissionType} )
    {   
        let strButtonText = ""

        switch (SubmissionType)
        {
            case SubmissionTypeEnum.Twice:
                strButtonText = window.gAppUI.LBL_Twice
                break
            case SubmissionTypeEnum.Unlimited:
                strButtonText = window.gAppUI.LBL_Unlimited
                break
            case SubmissionTypeEnum.Once:
            default:
                strButtonText = window.gAppUI.LBL_Once
                break
        } // end of switch (SubmissionType)

        return(
            <div className={cssContent.divRadioMain} 
                    onClick={() => RadioOnTapHandler(SubmissionType)}>
                <div className={GetRadioButtonCls(StateTestedCountMax, SubmissionType)}/>
                <div className={cssContent.divRadioButtonText}>
                    {strButtonText}
                </div>
            </div>
        )
    } // end of ComponentAllowSubmissionRadioButton

    /*===========================================
    summary: Switch Button 顯示Component  
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function ComponentSwitchButton( {StateShowValue, SwitchButtonType, SwitchValue} )
    {   
        let strButtonText = ""

        if (SwitchValue === SwitchValueEnum.OFF)
        {
            // Major
            strButtonText = window.gAppUI.BTN_OFF
        }
        else
        {
            // Minor
            strButtonText = window.gAppUI.BTN_ON
        }

        return(
            <div className={GetSwitchButtonCls(StateShowValue, SwitchValue)} 
                    onClick={() => SwitchButtonOnTapHandler(SwitchButtonType, SwitchValue)}>
                <div className={GetSwitchTextCls(StateShowValue, SwitchValue)} >
                    {strButtonText}
                </div> 
            </div> 
        )
    } // end of ComponentSwitchButton

    /*===========================================
    summary: Language Button 顯示Component  
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function ComponentLanguageButton( {StateLanguage, LangType} )
    {   
        let strButtonText = ""

        if (LangType === window.gLangTypeEnum.Major)
        {
            // Major
            strButtonText = window.gAppUI.BTN_Simplified
        }
        else
        {
            // Minor
            strButtonText = window.gAppUI.BTN_Traditional
        }

        return(
            <div className={GetLanguageButtonCls(StateLanguage, LangType)}
                    onClick={() => ContentLanguageOnTapHandler(LangType)}>
                <div className={GetLanguageTextCls(StateLanguage, LangType)}>
                    {strButtonText}
                </div>
            </div>
        )
    } // end of ComponentLanguageButton

    /*===========================================
    summary: Content Value Row 顯示Component  
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function ComponentContentValueRow( {Title, Value} )
    {   
        return(
            <div className={cssContent.divRowMain}>
                <div className={cssContent.divRowTitle}>
                    {Title}
                </div>
                <div className={cssContent.divRowText}>
                    {Value}
                </div>
            </div>
        )
    } // end of ComponentContentValueRow

    /*===========================================
    summary: Content Title 顯示Component  
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function ComponentContentTitle( {Title} )
    {   
        return(
            <>
                <div className={cssContent.divContentTitle}>
                    {Title}
                </div>

                <div className={cssContent.divTitleLine}/>
            </>
        )
    } // end of ComponentContentTitle

    /*===========================================
    summary: Content Submit Row 顯示Component  
    remarks: 000 Tim 2021/11/16 Create
    ===========================================*/
    function ComponentContentSubmitRow( {StateLanguage, StateShowPractice
        , StateShowReview, StateShowAnswer4Submission, StateTestedCountMax} )
    {   
        return(
            <div className={cssContent.divRowMain4Submit}>
                <div className={cssContent.btnSubmit} 
                        onClick={() => ContentSubmitOnTapHandler(StateLanguage, StateShowPractice
                            , StateShowReview, StateShowAnswer4Submission, StateTestedCountMax)}>
                    {window.gAppUI.BTN_Submit}
                </div>
            </div>
        )
    } // end of ComponentContentSubmitRow
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Content 學生作答次數 Row 顯示Component
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function RenderContentAllowSubmissionRowWrapper(StateTestedCountMax)
    {   
        return(
            <div className={cssContent.divRowMain}>
                <div className={cssContent.divRowTitle}>
                    {window.gAppUI.LBL_SubmissionMsg}
                </div>

                <ComponentAllowSubmissionRadioButton StateTestedCountMax={StateTestedCountMax} SubmissionType={SubmissionTypeEnum.Once} />
                <ComponentAllowSubmissionRadioButton StateTestedCountMax={StateTestedCountMax} SubmissionType={SubmissionTypeEnum.Twice} />
                <ComponentAllowSubmissionRadioButton StateTestedCountMax={StateTestedCountMax} SubmissionType={SubmissionTypeEnum.Unlimited} />
            </div>
        )
    } // end of RenderContentAllowSubmissionRowWrapper

    /*===========================================
    summary: Render Show Switch Row 顯示 
                支援 Show Practice / Show Review / ShowAnswer4Submission
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function RenderContentShowSwitchRowWrapper(StateShowValue, SwitchButtonType)
    {  
        let strTitle = ""
        if (SwitchButtonType === SwitchButtonTypeEnum.ShowPractice)
        {
            strTitle = window.gAppUI.LBL_PracticeMsg
        }
        else if (SwitchButtonType === SwitchButtonTypeEnum.ShowReview)
        {
            strTitle = window.gAppUI.LBL_ReviewMsg
        }
        else if (SwitchButtonType === SwitchButtonTypeEnum.ShowAnswer4Submission)
        {
            strTitle = window.gAppUI.LBL_AnswerMsg
        }

        return(
            <div className={cssContent.divRowMain}>
                <div className={cssContent.divRowTitle}>
                    {strTitle}
                </div>

                <div className={cssContent.divSwitchButtonBG}>
                    <ComponentSwitchButton StateShowValue={StateShowValue} SwitchButtonType={SwitchButtonType} SwitchValue={SwitchValueEnum.OFF} />
                    <ComponentSwitchButton StateShowValue={StateShowValue} SwitchButtonType={SwitchButtonType} SwitchValue={SwitchValueEnum.ON} />
                </div>                        
            </div>
        )
    } // end of RenderContentShowSwitchRowWrapper
    
    /*===========================================
    summary: Render 老師區域 內容 的顯示
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function RenderTeacherContentWrapper()
    {
        if (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_TEACHER)
        {
            return (
                <>
                    <div className={cssContent.divContentAreaMain}>
                        <ComponentContentTitle Title={window.gAppUI.LBL_ContentsAccess} />

                        {RenderContentShowSwitchRowWrapper(showPractice, SwitchButtonTypeEnum.ShowPractice)}
                        {RenderContentShowSwitchRowWrapper(showReview, SwitchButtonTypeEnum.ShowReview)}
                    </div>


                    <div className={cssContent.divContentAreaMain}>
                        <ComponentContentTitle Title={window.gAppUI.LBL_AssignmentSetting} />
                        
                        {RenderContentShowSwitchRowWrapper(showAnswer4Submission, SwitchButtonTypeEnum.ShowAnswer4Submission)}

                        {RenderContentAllowSubmissionRowWrapper(testedCountMax)}
                    </div>
                </>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderTeacherContentWrapper

    /*===========================================
    summary: Render Language Row 顯示
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function RenderContentLanguageRowWrapper()
    {   
        return(
            <div className={cssContent.divRowMain}>
                <div className={cssContent.divRowTitle}>
                    {window.gAppUI.LBL_ChineseCharacters}
                </div>
                
                <ComponentLanguageButton StateLanguage={language} LangType={window.gLangTypeEnum.Major} />
                <ComponentLanguageButton StateLanguage={language} LangType={window.gLangTypeEnum.Minor} />
            </div>
        )
    } // end of RenderContentLanguageRowWrapper

    /*===========================================
    summary: Render Content 內容 的顯示
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function RenderContentWrapper()
    {
        return (
            <>
                <ComponentContentSubmitRow StateLanguage={language}
                    StateShowPractice={showPractice} 
                    StateShowReview={showReview}
                    StateShowAnswer4Submission={showAnswer4Submission} 
                    StateTestedCountMax={testedCountMax}/>

                <ComponentContentTitle Title={window.gAppUI.LBL_ContentSettingsTitle} />

                <ComponentContentValueRow Title={window.gAppUI.LBL_SystemLanguage} 
                    Value={window.gAppUI.LBL_English}/>

                {RenderContentLanguageRowWrapper()}
                    
                {RenderTeacherContentWrapper()}
            </>
        )
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function RenderMainWrapper(StateUpdateDataTime)
    {
        if (StateUpdateDataTime > 0)
        {
            return (
                <>
                    {RenderContentWrapper()}
                </>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper(updateDataTime)}
        </>
    )
    // #endregion Render
}
export default Content